import { render, staticRenderFns } from "./FormInputText.vue?vue&type=template&id=6968f70d&scoped=true&"
import script from "./FormInputText.vue?vue&type=script&lang=js&"
export * from "./FormInputText.vue?vue&type=script&lang=js&"
import style0 from "./FormInputText.vue?vue&type=style&index=0&id=6968f70d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968f70d",
  null
  
)

export default component.exports